export function isNonNullFilter<T>(value: T): value is NonNullable<T> {
  return value != null;
}
